export default [
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'ID',
    },
    cell: {
      type: 'slot',
      name: 'id',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Type',
    },
    cell: {
      type: 'slot',
      name: 'type',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Renter',
    },
    cell: {
      type: 'slot',
      name: 'renter',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Occupancy',
    },
    cell: {
      type: 'slot',
      name: 'occupancy',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Supported crypto',
    },
    cell: {
      type: 'slot',
      name: 'supportedCrypto',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Supported fiat',
    },
    cell: {
      type: 'slot',
      name: 'supportedFiat',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Status',
    },
    cell: {
      type: 'slot',
      name: 'status',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: 'Last time used',
    },
    cell: {
      type: 'slot',
      name: 'lastTimeUsed',
    },
  },
  {
    width: 10,
    header: {
      type: 'text',
      caption: '',
    },
    cell: {
      type: 'slot',
      name: 'actions',
    },
  },
];
